// extracted by mini-css-extract-plugin
export default {"dodoLogo":"Info_dodoLogo__GL-vk","infoHeader":"Info_infoHeader__Z55eY","infoHeaderLeft":"Info_infoHeaderLeft__LPSCg","btnClose":"Info_btnClose__d9PDW","fixed":"Info_fixed__FVhRq"};